// GDMCOMMENT: Latitudes and longitudes used in this file are either sourced from GrabPlaces, GrabMaps, OSM or randomly created by the developer and are not obtained from other external sources.
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import GrabMaps, { Marker as GrabMarker } from '@geo/grab-maps';
import { Modal, Input } from 'grab-ui';
import get from 'lodash/get';
import AddressField from 'components/v2/address-field/address-field.jsx';
import pickUpPinSvg from 'public/images/pick-up-pin.svg';
import dropOffPinSvg from 'public/images/drop-off-2.svg';
import { getMapTilesURL } from 'constants/app-constants';
import styles from './address-picker-modal.less';

const GrabMap = GrabMaps({
  dragRotate: false,
});

class AddressPickerModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addressEntity: {
        keywords: get(props, ['presetAddressEntity', 'keywords']),
        address: get(props, ['presetAddressEntity', 'address']),
        instruction: get(props, ['presetAddressEntity', 'instruction']),
        latlng: get(props, ['presetAddressEntity', 'latlng']),
      },
    };
  }

  onSelectAddress = (_, addressEntity) => {
    this.setState({
      addressEntity: {
        ...this.state.addressEntity,
        address: get(addressEntity, ['address', 'combined_address']),
        keywords: get(addressEntity, ['address', 'name']),
        countryID: get(addressEntity, ['address', 'country_id']),
        cityID: get(addressEntity, ['address', 'cityId']),
        poiID: get(addressEntity, 'id'),
        latlng: get(addressEntity, 'latlng'),
      },
    });
  };

  onInstructionChange = e => {
    this.setState({
      addressEntity: {
        ...this.state.addressEntity,
        instruction: e.target.value,
      },
    });
  };

  confirmPickAddress = () => {
    const { addressEntity } = this.state;
    const { onPickAddress } = this.props;
    onPickAddress(addressEntity);
  };

  cancelPickAddress = () => {
    this.props.onCancel();
  };

  render() {
    const { addressEntity } = this.state;
    const {
      title,
      subtitle,
      visible,
      isPickupAddress,
      fetchAddressFunc,
    } = this.props;
    const { latlng, instruction, keywords, address } = addressEntity;
    return (
      <Modal
        centered
        visible={visible}
        onOk={this.confirmPickAddress}
        onCancel={this.cancelPickAddress}
        className={styles.addressPickerModal}
        okText={I18n.t('shopify.orders.addressPickerModal.confirm')}
        cancelText={I18n.t('shopify.orders.addressPickerModal.cancel')}
        closable={false}
      >
        <div className={styles.header}>
          <h1 className={styles.title}>{title}</h1>
          {subtitle && <h2 className={styles.subtitle}>{subtitle}</h2>}
        </div>
        <div className={styles.map}>
          {latlng && (
            <GrabMap
              mapStyle={getMapTilesURL()}
              center={[latlng.longitude, latlng.latitude]}
              zoom={11}
              fitBoundsOptions={{
                offset: [30, 30],
              }}
            >
              <GrabMarker
                coordinates={[latlng.longitude, latlng.latitude]}
                anchor="bottom"
              >
                <img
                  alt="dropoff"
                  src={isPickupAddress ? pickUpPinSvg : dropOffPinSvg}
                />
              </GrabMarker>
            </GrabMap>
          )}
        </div>
        <div className={styles.inputs}>
          <AddressField
            index={1}
            initialValue={{ keywords, address }}
            fetchAddressFunc={fetchAddressFunc}
            placeholder={I18n.t(
              'shopify.orders.addressPickerModal.addressPlaceholder',
            )}
            showNumbers={false}
            onSelectAddress={this.onSelectAddress}
            enableDelete={false}
            isPickupAddress={isPickupAddress}
          />
          <Input
            className={styles.instructionInput}
            value={instruction}
            onChange={this.onInstructionChange}
            placeholder={I18n.t(
              'shopify.orders.addressPickerModal.locationNotesPlaceholder',
            )}
          />
        </div>
      </Modal>
    );
  }
}

AddressPickerModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  isPickupAddress: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onPickAddress: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  fetchAddressFunc: PropTypes.func.isRequired,
};

AddressPickerModal.defaultProps = {
  title: '',
  subtitle: '',
  visible: false,
  isPickupAddress: false,
};

export default AddressPickerModal;
